(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.paragraph_image_gallery = {
    attach: function (context, settings) {

      $(once('slick', '.paragraph--type--image-gallery .field--name-field-images')).each(function(_, $el) {
        $($el).slick({
          // dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          // centerMode: true,
          // variableWidth: true,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          lazyLoad: 'progressive',
          appendDots: $($el).parent(),
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                // slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3,
              }
            }
          ]
        });
      });

    }
  };

})(jQuery, Drupal, this, this.document);
